import { Stack } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";

type ProfileItemProps = {
  profileName: string;
  email: string;
};

export const ProfileItem = ({ profileName, email }: ProfileItemProps) => (
  <Stack gap={null}>
    <Typography withMargin variant="bodyBold" tag="span">
      {profileName}
    </Typography>
    <Typography withMargin variant="labelRegular" tag="span">
      {email}
    </Typography>
  </Stack>
);
